import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17dc7f76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer l-footer" }
const _hoisted_2 = { class: "c-fmenu" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "c-cr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("a", {
              class: "logout",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut()))
            }, "ログアウト")
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerLinks, (f, i) => {
        return (_openBlock(), _createElementBlock("li", { key: i }, [
          _createElementVNode("a", {
            href: f.url,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(f.title), 9, _hoisted_4)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.footerCopy), 1)
  ]))
}